import { jsx as _jsx } from "react/jsx-runtime";
import { DatePicker as HeroDatePicker } from '@heroui/react';
export const DatePicker = (props) => {
    return _jsx(HeroDatePicker, { ...props });
};
//# sourceMappingURL=DatePicker.js.map